import type * as Stitches from '@stitches/react';
import { styled } from '../../../theme/stitches.config';

export const SMPContainer = styled.withConfig({ componentId: 'CommonWidget', displayName: 'SMPContainer' })('div', {
  // Reset
  boxSizing: 'border-box',
  flexShrink: 0,
  fontFamily: '$primaryFontFamily',

  // Custom
  ml: 'auto',
  mr: 'auto',
  px: '$3',

  variants: {
    size: {
      '0': {
        maxWidth: '300px',
      },
      '1': {
        maxWidth: '430px',
      },
      '2': {
        maxWidth: '768px',
      },
      '3': {
        maxWidth: '1145px',
      },
      '4': {
        maxWidth: 'none',
      },
      '5': {
        maxWidth: '2000px',
      },
      '6': {
        maxWidth: '4000px',
      },
    },
    live: {
      true: {
        position: 'relative',
        '&::before': {
          content: '',
          width: '4px',
          top: '12%',
          height: '75%',
          background: '$green500',
          position: 'absolute',
          borderRadius: '0 $3 $3 0',
        },
      },
    },
    variant: {
      oddsContainer: {
        backgroundColor: '$oddsContainerPrimaryBgColor',
        py: '$2',
      },
      transparentOddsContainer: {
        backgroundColor: 'transparent',
        py: '$2',
      },
      oddItemContainer: {
        backgroundColor: '$oddItemPrimaryBgColor',
        px: '$2',
      },
      sportEntityContainer: {
        backgroundColor: '$sportEntityContainerPrimaryBgColor',
        py: '$3',
      },
      livescoreTournamentContainer: {},
      groupSectionTitleContainer: {},
      livescoreCompetitionContainer: {
        py: '$3',
      },
      livescoreMatchesContainer: {
        px: 0,
      },
      paddinglessContainer: {
        px: 0,
      },
      footballSingleEventContainer: {
        backgroundColor: '$sportEntityContainerPrimaryBgColor',
        pr: '$3',
        pl: 0,
        py: '$3',
      },
      footballSingleEventTournamentContainer: {
        pl: '$3',
        pr: '$3',
        pt: '$2',
        pb: '$1',
      },
      singleEventRoundContainer: {
        pl: '$3',
        pr: '$3',
        pb: '$3',
      },
      oddsContainerSingleLine: {
        px: '0',
        py: '$2',
        backgroundColor: '$oddsContainerPrimaryBgColor',
      },
    },
  },
  defaultVariants: {
    size: '4',
  },
  compoundVariants: [
    {
      variant: 'sportEntityContainer',
      live: true,
      css: {
        position: 'relative',
        '&::before': {
          content: '',
          width: '4px',
          top: '12%',
          left: '0',
          height: '75%',
          background: '$green500',
          position: 'absolute',
          borderRadius: '0 $3 $3 0',
        },
      },
    },
  ],
});

export type StyledSMPContainerVariants = Stitches.VariantProps<typeof SMPContainer>;
